import React from 'react'

import { ConfirmationModal, ModalActionTypes } from '@acorns/web-components'

import AlertBadge from 'assets/icons/alert-badge.png'

type Props = {
  exception: string
  openExceptionModal: boolean
  closeExceptionModal: () => void
  emailNotificationEnabled?: boolean
  suspensionReasonValidForEmailNotification?: boolean
}

const AuthenticateExceptionHandler = (props: Props) => {
  if (props.exception === 'UserLockedException') {
    return (
      <ConfirmationModal
        isOpen={props.openExceptionModal}
        actions={[
          {
            label: 'Reset password',
            type: ModalActionTypes.primary,
            href: '/forgot-password',
          },
        ]}
        title="Account locked"
        message="Due to unusual activity, we’ve locked your account to keep your money safe. Please update your password to unlock it"
        image={AlertBadge}
      />
    )
  } else if (props.exception === 'InvalidCredentialsException') {
    return (
      <ConfirmationModal
        isOpen={props.openExceptionModal}
        actions={[
          {
            handler: props.closeExceptionModal,
            label: 'Try Again',
            type: ModalActionTypes.danger,
          },
        ]}
        title="Login Error"
        message="The email and password combination you entered is incorrect."
        image={AlertBadge}
      />
    )
  } else if (props.exception === 'DeviceBlockedException') {
    return (
      <ConfirmationModal
        isOpen={props.openExceptionModal}
        actions={[
          {
            handler: props.closeExceptionModal,
            label: 'Go back',
            type: ModalActionTypes.secondary,
          },
        ]}
        title="Sorry about this"
        message="For security reasons, we have blocked this device from further login attempts. We sent an email with instructions to regain access to your account."
        image={AlertBadge}
      />
    )
  } else if (props.exception === 'UserSuspendedException') {
    if (
      props.emailNotificationEnabled &&
      props.suspensionReasonValidForEmailNotification
    ) {
      return (
        <ConfirmationModal
          isOpen={props.openExceptionModal}
          actions={[
            {
              href: 'https://help.acorns.com/contact',
              label: 'Contact Support',
              type: ModalActionTypes.secondary,
            },
            {
              handler: props.closeExceptionModal,
              label: 'OK',
              type: ModalActionTypes.primary,
            },
          ]}
          title="Acorns Account Suspended"
          message="For security purposes, we've temporarily suspended your Acorns account. Please check your email for instructions on how to regain access. Or, feel free to contact our Support team."
          image={AlertBadge}
        />
      )
    }
    return (
      <ConfirmationModal
        isOpen={props.openExceptionModal}
        actions={[
          {
            handler: props.closeExceptionModal,
            label: 'Cancel',
            type: ModalActionTypes.secondary,
          },
          {
            href: 'https://help.acorns.com/contact',
            label: 'Contact Support',
            type: ModalActionTypes.primary,
          },
        ]}
        title="Acorns Account Suspended"
        message="For your security, we’ve suspended your Acorns account. This may be because fraudulent activity was detected. Please contact our support team for help."
        image={AlertBadge}
      />
    )
  } else if (props.exception === 'LoginRateLimitedException') {
    return (
      <ConfirmationModal
        isOpen={props.openExceptionModal}
        actions={[
          {
            handler: props.closeExceptionModal,
            label: 'Go Back',
            type: ModalActionTypes.secondary,
          },
        ]}
        title="Sorry about this"
        message="For your security, we limit login attempts and that limit has been met. Please wait a few minutes and try again."
        image={AlertBadge}
      />
    )
  } else {
    return null
  }
}

export default AuthenticateExceptionHandler
